module.exports = __webpack_public_path__ + "static/media/4 (1).55f8d5df.webp";